<template>
<div>
  <van-tabbar v-model="active" style="-webkit-user-select:none;">
    <van-tabbar-item icon="home-o" @click="goTo(0)">
      <template #icon="props">
        <svg-icon :icon-class="props.active ?'tabStrategyOn':'tabStrategy'" style="width:21px;height:21px;"></svg-icon>
      </template>
      策略</van-tabbar-item>
    <van-tabbar-item icon="search" @click="goTo(1)">
      <template #icon="props">
        <svg-icon :icon-class="props.active ?'tabMarketOn':'tabMarket'" style="width:21px;height:21px;"></svg-icon>
      </template>
      行情</van-tabbar-item>
    <van-tabbar-item icon="friends-o" @click="goTo(2)">
      <template #icon="props">
        <svg-icon :icon-class="props.active ?'tabNewsFlashOn':'tabNewsFlash'" style="width:21px;height:21px;"></svg-icon>
      </template>
      快讯</van-tabbar-item>
    <van-tabbar-item icon="setting-o" @click="goTo(3)">
      <template #icon="props">
        <svg-icon :icon-class="props.active ?'tabMyOn':'tabMy'" style="width:21px;height:21px;"></svg-icon>
      </template>
      我的</van-tabbar-item>
  </van-tabbar>
</div>
</template>

<script>
export default {
  name: "v_menu",
  data(){
    return{
      active: 0,
      menuOp:['/strategy','/market','/newsFlash','/userCenter']

    }
  },
  methods:{
    goTo(val){
      if (this.$route.fullPath.indexOf(this.menuOp[val]) === -1){
        this.$router.push(this.menuOp[val])
      }

    },
    agreement(){
      for(let i=0;i<this.menuOp.length;i++){
        if (this.$route.path.indexOf(this.menuOp[i]) !== -1){
          this.active = i;
          break;
        }
      }
    }
  },
  created() {
    this.agreement()
  },
  watch:{
    $route() {
      this.agreement()
    }
  }
}
</script>

<style scoped>

</style>
